module.exports = __webpack_public_path__ + "img/image05.e3d36d86.jpg";